/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AssistedSchedulerComponent } from '../assisted-scheduler/assisted-scheduler.component';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-add-service-task',
  templateUrl: './add-service-task.component.html',
  styleUrls: ['./add-service-task.component.scss']
})
export class AddServiceTaskComponent implements OnInit {

  currentPage: number = 1;
  totalRecords: number = 1;
  count: number = 5;
  allTasks: any[] = [];
  search: string = '';
  lineItemsDisplayedColumns: Array<string> = ['checkbox', 'service_task', 'description', 'inspection_form', 'estimated_duration'];
  loaded: boolean = false;
  masterTaskObj: any = {};
  selectedTasks: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssistedSchedulerComponent>,
    private _dataCollectorService: DataCollectorService,
    private _jobService: JobsService,
    private _toast: HotToastService,
    public utilityService: UtilityService
  ) { }

  clearSearch(): void{
    this.search = '';
    this.allTasks = [];
    this.currentPage = 1;
    this.getServiceTask();
  }

  getServiceTask(): void{
    this.loaded = false;
    const filter = {
      'count': this.count,
      'page': this.currentPage,
      'sort': 'DESC',
      'sort_by': 'created_at',
      'filter.keyword': this.search,
      'filter.is_active': true
    };
    this._dataCollectorService.getData(this._jobService.getServiceTaskMaster(), filter)
      .subscribe((res: any) => {
        this.loaded = true;
        this.allTasks = res?.data;
        if(this.allTasks?.length > 0) {
          this.allTasks.forEach((task: any)=>{
            if(!this.masterTaskObj[task.service_task_master_uid]){
              this.masterTaskObj[task.service_task_master_uid] = {
                status: false
              };
            }
          });
        }
        this.totalRecords = res?.total_records;
      },(err: any) => {
        
      });
  }

  getTaskValue(task: any): boolean {
    return this.masterTaskObj?.[task?.service_task_master_uid]?.['status'];
  }

  toggleServiceTask(task: any): any {
    this.masterTaskObj[task.service_task_master_uid]['status'] = !this.masterTaskObj[task.service_task_master_uid]['status'];
    if(this.masterTaskObj[task.service_task_master_uid]['status']){
      this.selectedTasks.push(task);
    }else{
      this.selectedTasks = this.selectedTasks.filter((ele: any) => ele?.service_task_master_uid !== task?.service_task_master_uid);
    }
  }

  addTask(): void {
    this.dialogRef.close(this.selectedTasks);
  }

  onPageItemEvent(event: any): void {
    this.currentPage = event.pageIndex + 1;
    this.getServiceTask();
  }

  closeDrawer(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.getServiceTask();
  }

}
